import { useAppSelector } from "./useAppSelector";

export const useAdminConfig = () =>
  useAppSelector((state: any) => state.configuration.config);
